import React from "react";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import { alpha, styled } from "@mui/material/styles";
import { Button, TablePagination } from "@mui/material";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow"; 
import { useState, useEffect } from "react";
import ViewModel from "../ViewModal";
import createInstance from "../../../api/axiosinstance";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? " #1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const CandidatePerformance = ({ onOpenAddOrganization }) => {

  const aiDishaApi = createInstance("DISHA");
  const [name, setName] = useState("");
  //const organizationId = window.sessionStorage.getItem("organizationId");
  const organizationId = "ORGID000002";
  console.log("ORGID"+organizationId);
  const [candidates, setCandidates] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [feedback, setFeedback] = useState("");
  const [rating, setRating] = useState("");
  const [candidateId, setCandidateId] = useState("");

  const handleChange = (event) => {
    setName(event.target.value);
  };

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const [isViewModalOpen, setIsViewModalOpen] = useState(false);

  const handleViewModalOpen = (n) => {
    console.log("AAAA",n.rating,n.feedback,n.candidate_id);
    setRating(n.rating);
    setFeedback(n.feedback);
    setCandidateId(n.candidate_id);
    console.log("BBBB",rating,feedback);
    
    setIsViewModalOpen(true);
  };

  const handleViewModalClose = () => {
    setIsViewModalOpen(false);
  };

  const handleAddOrganizationClick = () => {
    onOpenAddOrganization(); // Call the function passed from AdminLandingPage
  };

  useEffect(()=>{

    getCandidates();
  },[]);

  const getCandidates = async () => {
    await aiDishaApi.get(`/candidates-performance-by-org-id?org_id=${organizationId}`)
    .then((response)=>{
      setCandidates(response.data);
      console.log(response.data);
    })
    .catch((error)=>{
      console.log("Error fetching candidates," + error);
    })
  }

  const roles = [
    {
      id: "Candidate ID",
      name: "Candidate Name",
      position: "Applied Position",
      date: "Interview Date",
      status: "Interview Status",
      action: "Action",
    },
  ];


  const filteredCandidates = candidates.filter((row) => 
    row.candidate_name?.toLowerCase().includes(searchTerm.toLowerCase()) 
  );

  return (
    <div>
      <Box
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        sx={{
          marginTop: "auto",
          alignItems: "center",
          borderRadius: "10px",
          padding: "1% 1%",
        }}
      >
        <Box gridColumn="span 12" sx={{ marginTop: "auto", textAlign: "left", marginBottom: "0%" }} >
          <Typography
            sx={{ fontFamily: "poppins", fontSize: "28px", color: "#033538" }}
          >
            Candidate Performance
          </Typography>
        </Box>

        <Box
          gridColumn="span 12"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
        >
          <Paper
            sx={{
              p: "2px 4px",
              display: "flex",
              width: "65%",
              borderRadius: 2,
              border: "1px solid #A7A7A7",
              backgroundColor:"#033538"
            }}
          >
            <IconButton type="button" sx={{ p: "8px" }} aria-label="search">
              <SearchIcon />
            </IconButton>
            <InputBase
              sx={{ ml: 1, 
                flex: 1, 
                fontFamily: "poppins", color:"white"}}
              placeholder="Search by Candidate Name"
              inputProps={{ "aria-label": "search google maps" }}
              value={searchTerm} onChange={handleSearch}
            />
          </Paper>
        </Box>  
      </Box>
      <Box xs={1} sx={{ backgroundColor: "#33333" }}>
        <Grid container spacing={1} sx={{ justifyContent: "center" }}>
          <Grid item xs={10}>
            <TableContainer
              component={Paper}
              sx={{
                marginTop: "25px",
                borderRadius: "10px",
              }}
            >
              <Table size="small">
                <TableHead sx={{ backgroundColor: "#006A71" }}>
                  {roles.map((role) => (
                    <TableRow key={role.id}>
                      <TableCell sx={{ color: "white", borderBottom: 0, borderLeft: "1px solid black"   }}>{role.id}</TableCell>
                      <TableCell sx={{ color: "white", borderBottom: 0  }}>
                        {role.name}
                      </TableCell>
                      <TableCell sx={{ color: "white", borderBottom: 0  }}>
                        {role.position}
                      </TableCell>
                      <TableCell sx={{ color: "white", borderBottom: 0}}>
                        {role.date}
                      </TableCell>
                      <TableCell sx={{ color: "white", borderBottom: 0 }}>
                        {role.status}
                      </TableCell>
                      <TableCell sx={{ color: "white", borderBottom: 0 }}>
                        {role.action}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableHead>
                <TableBody>
                  {filteredCandidates && filteredCandidates
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((n, index) => (
                      <TableRow
                        key={n.candidate_id}
                        sx={{ backgroundColor: "#033538", marginRight: "30px" }}
                      >
                        <TableCell
                          sx={{ color: "#A7A7A7", border: "1px solid black" }}
                        >
                          {n.candidate_id}
                        </TableCell>
                        <TableCell
                          sx={{ color: "white", border: "1px solid black" }}
                        >
                          {n.candidate_name}
                        </TableCell>
                        <TableCell
                          sx={{ color: "white", border: "1px solid black" }}
                        >
                          {n.applied_position}
                        </TableCell>                       
                        <TableCell
                          sx={{ color: "#A7A7A7", border: "1px solid black" }}
                        >
                          {n.interview_date}
                        </TableCell>
                        <TableCell
                          sx={{ color: "white", border: "1px solid black" }}
                        >
                          {n.status}
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom:"1px solid black",
                            borderRight:"1px solid black",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Button
                            variant="contained"
                            sx={{
                              backgroundColor: "black",
                              color: "white",
                              marginRight: "10px",
                              fontFamily: "poppins",
                              height: "20px",
                              width: "80px",
                            }}
                            onClick={()=>handleViewModalOpen(n)}
                          >
                            View
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </Box>
      <ViewModel isOpen={isViewModalOpen} onClose={handleViewModalClose} title="Candidate Performance" feedback={feedback} rating={rating} candidateId={candidateId}/>
    </div>
  );
};
export default CandidatePerformance;
